import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { SaveUserAddressInfoinAllApplications, zipAndBranchDetail } from '../../../AdminActionCreator.component';

const currentResidenceTypeData = [
    { value: 'Rented', label: 'Rented' },
    { value: 'Own', label: 'Own' },
]


const textFieldData = [
    { label: "Address Type", value: "currentResidenceType", placeholder: "Enter Address Type", type: "text", name: "currentResidenceType" },
    { label: "Rented Amount (if Rented)", value: "currentMonthlyRent", placeholder: "Enter Rented Amount", type: "number", name: "currentMonthlyRent" },
    { label: "Duration", value: "currentResidenceValue", placeholder: "Enter Duration", type: "number", name: "currentResidenceValue" },
    { label: "Pincode", value: "currentPincode", placeholder: "Enter Pincode", type: "text", name: "currentPincode" },
    { label: "Current Address", value: "currentAddress", placeholder: "Enter Current Address", type: "text", name: "currentAddress" },
    { label: "Current Town", value: "currentTown", placeholder: "Enter CurrentTown", type: "text", name: "currentTown" },
    { label: "Current City", value: "currentCity", placeholder: "Enter Current City", type: "text", name: "currentCity" },
    { label: "Current Landmark", value: "currentLandmark", placeholder: "Enter Current Landmark", type: "text", name: "currentLandmark" },
    { label: "Current District", value: "currentDistrict", placeholder: "Enter Current District", type: "text", name: "currentDistrict" },
    { label: "Current State", value: "currentState", placeholder: "Enter Current State", type: "text", name: "currentState" },
]

export default function EditPersonalDetail({ data, closePopup, customStyle, handleLoader, handleTextPopup, closeTextPopup }) {
    const [objectData, setObjectData] = useState({
        "currentResidenceType": "",
        "currentMonthlyRent": "",
        "currentResidenceValue": "",
        "currentPincode": "",
        "currentAddress": "",
        "currentTown": "",
        "currentCity": "",
        "currentLandmark": "",
        "currentDistrict": "",
        "currentState": "",
    });

    const handleInputValues = (e) => {
        const { name, value } = e.target;

        if (name == "currentPincode" && e.target.value?.length == 6) {
                handlezipAndBranchDetailFn(e.target.value)
        }

        setObjectData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    useEffect(() => {
        console.log("data", data)
        if (data?.userId) {
            setObjectData({
                "currentResidenceType": data?.addressDetailsPO?.currentResidenceType || "",
                "currentMonthlyRent": data?.addressDetailsPO?.currentMonthlyRent || "",
                "currentResidenceValue": data?.addressDetailsPO?.currentStayDuration || "",
                "currentPincode": data?.addressDetailsPO?.currentPincode || "",
                "currentAddress": data?.addressDetailsPO?.currentAddress || "",
                "currentTown": data?.addressDetailsPO?.currentTown || "",
                "currentCity": data?.addressDetailsPO?.currentCity || "",
                "currentLandmark": data?.addressDetailsPO?.currentLandmark || "",
                "currentDistrict": data?.addressDetailsPO?.currentDistrict || "",
                "currentState": data?.addressDetailsPO?.currentState || "",
            })
        } else {
            setObjectData({
                "currentResidenceType": "",
                "currentMonthlyRent": "",
                "currentResidenceValue": "",
                "currentPincode": "",
                "currentAddress": "",
                "currentTown": "",
                "currentCity": "",
                "currentLandmark": "",
                "currentDistrict": "",
                "currentState": "",
            })
        }
    }, [])


    const handleSave = () => {
        const obj = { ...objectData, userId: data?.userId,formStatus:"" }
        handleLoader(true)
        SaveUserAddressInfoinAllApplications(obj, callback => {
            if (callback?.message == "success" && callback?.status == 200) {
                handleTextPopup(true, "Current Address Information Updated Successfully")
            } else {
                handleTextPopup(true, "Error Updating Current Address Information")
            }
            handleLoader(false)
            closeTextPopup()
        })
    }

    const handlezipAndBranchDetailFn = (value) => {
        handleLoader(true)
        zipAndBranchDetail(value, 'zip', res => {
            handleLoader(false)
            if (res.status === 'success') {
                setObjectData((prev)=>({
                    ...prev,
                    currentCity: res.city,
                    currentDistrict: res.destrict,
                    currentState: res.state,
                }))
            }
        })
    }


    return (
        <>
            <div className='background-blur income' style={customStyle}>
                <div className='popup-main small-popup container-fluid dbl-border'>
                    <button className='close' onClick={e => closePopup()}>
                        &times;
                    </button>
                    <h4 style={{ color: '#000' }}>Edit Current Address Details</h4>

                    <div className="row">
                        {
                            textFieldData && textFieldData?.map((value, index) => {
                                return (
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>

                                        {
                                            value?.name !== "currentResidenceType" ?

                                                <TextField fullWidth id="outlined-basic" label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]}
                                                    placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} />
                                                :
                                                value?.name == "currentResidenceType" ?
                                                    <TextField fullWidth id="outlined-basic" select label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]} placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} >
                                                        {currentResidenceTypeData?.map((option) => (
                                                            <MenuItem key={option.value} value={option.label}>
                                                                {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                    :
                                                    ""
                                        }

                                    </div>
                                )
                            })
                        }

                        <div className="col-xs-12" style={{ marginTop: '20px', textAlign: 'center' }}>
                            <button className='btn btn-primary' onClick={() => handleSave()}>Save</button>
                        </div>
                    </div>

                </div>


            </div >
        </>
    )
}
